exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/add-sponsorship/add-sponsorship.component.scss
// module id = ../../../../../src/app/components/add-sponsorship/add-sponsorship.component.scss
// module chunks = main